import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { appsAPI, pagesAPI, settingsAPI } from '../../services/api'
import BrandMark from './BrandMark'

import { logger } from '@/utils/logger';
export default function Footer() {
  const [pages, setPages] = useState([])
  const [apps, setApps] = useState([])
  const [settings, setSettings] = useState({
    footer_company_name: 'Werkstatt-Connect',
    footer_company_description: 'Ihre professionelle Lösung für digitale Werkstatt-Verwaltung',
    footer_contact_email: 'info@werkstatt-connect.de',
    footer_contact_phone: '+49 (0) 123 456789',
    footer_copyright: 'Werkstatt-Connect. Alle Rechte vorbehalten.',
  })

  useEffect(() => {
    loadPages()
    loadApps()
    loadSettings()
  }, [])

  const loadPages = async () => {
    try {
      const response = await pagesAPI.getAll()
      setPages(response.data)
    } catch (error) {
      logger.error('Error loading pages:', error)
    }
  }

  const loadApps = async () => {
    try {
      const response = await appsAPI.getAll()
      setApps(response.data)
    } catch (error) {
      logger.error('Error loading apps:', error)
    }
  }

  const loadSettings = async () => {
    try {
      const response = await settingsAPI.getPublic()
      const settingsMap = {}
      response.data.forEach(setting => {
        settingsMap[setting.key] = setting.value
      })
      setSettings(prev => ({ ...prev, ...settingsMap }))
    } catch (error) {
      logger.error('Error loading settings:', error)
    }
  }

  return (
    <footer style={{ borderTop: '1px solid var(--wc-divider)', marginTop: 'auto' }}>
      <div
        className="wc-container wc-footer-grid"
        style={{
          padding: '56px 32px 32px',
          display: 'grid',
          gridTemplateColumns: '1.4fr 1fr 1fr',
          gap: 40,
        }}
      >
        <div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 16,
              marginBottom: 12,
            }}
          >
            <BrandMark size={18} />
            {settings.footer_company_name}
          </div>
          <p className="wc-muted" style={{ fontSize: 14, maxWidth: 320 }}>
            {settings.footer_company_description}
          </p>
        </div>

        <div>
          <h6 style={{ marginBottom: 14 }}>Apps</h6>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              fontSize: 14,
            }}
          >
            {apps.map(app => (
              <Link key={app.id} to={`/apps/${app.slug}`} className="wc-footer-link">
                {app.name}
              </Link>
            ))}
            <Link to="/apps" className="wc-footer-link">
              Alle Apps
            </Link>
          </div>
        </div>

        <div>
          <h6 style={{ marginBottom: 14 }}>Kontakt</h6>
          <div
            className="wc-muted"
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              fontSize: 14,
            }}
          >
            {settings.footer_contact_email && (
              <a
                href={`mailto:${settings.footer_contact_email}`}
                className="wc-footer-link"
              >
                {settings.footer_contact_email}
              </a>
            )}
            {settings.footer_contact_phone && (
              <span>{settings.footer_contact_phone}</span>
            )}
            <Link to="/contact" className="wc-footer-link">
              Kontaktformular
            </Link>
          </div>
        </div>
      </div>

      <div className="wc-container">
        <div className="wc-hr" style={{ margin: 0 }}></div>
      </div>

      <div
        className="wc-container wc-muted wc-footer-bottom"
        style={{
          padding: '20px 32px 32px',
          display: 'flex',
          justifyContent: 'space-between',
          gap: 16,
          flexWrap: 'wrap',
          fontSize: 12,
        }}
      >
        <div>
          © {new Date().getFullYear()} {settings.footer_copyright}
        </div>
        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
          {pages.map(page => (
            <Link key={page.id} to={`/${page.slug}`} className="wc-footer-link">
              {page.title}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  )
}
